<template>
	<div class="centerWidth">
		<div class="gaokao">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>查:职业查询</span>
			</div>
			<section class="gaokao-content">
				<div class="my-title">职业查询</div>
				<div class="chaBg">
					<p v-for="(item, index) in labelList" :key="index" :class="isTab == item.Id ? 'on' : ''" @click="tabClick(item.Id)">
						<!-- <a :href="'#T' + item.Id" >{{ item.TypeName }}</a> -->
						<a href="javascript:void(0)" @click="handleAnchor(item.Id)">{{ item.TypeName }}</a>
					</p>
				</div>

				<section class="chaList">
					<ul>
						<li v-for="(item, index) in list" :key="index">
							<h6 :id="'T' + item.Id">{{ item.TypeName }}</h6>
							<dl>
								<dd >
									<!-- <h5>
										<span>•</span>
									</h5> -->
									<hgroup>
										<p v-for="(child, index) in item.Children" :key="index" @click="goDetail(child)">{{ child.TypeName }}</p>
									</hgroup>
								</dd>
							</dl>
						</li>
					</ul>
				</section>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isTab: 0,
			labelList: [],
			list: []
		};
	},

	// 加载
	created() {
		if (this.$route.query.key) {
			this.$api.reduceUserCount({ key: this.$route.query.key });
		} else {
			this.$router.back(-1);
		}
		// this.GetProfessionalTypeByPage();
		this.GetProfessionalTypeAoll();
	},
	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 点击跳转到锚点
		handleAnchor(id) {
			const dom = document.getElementById(`T${id}`);
			if (dom) {
				dom.scrollIntoView(true);
				dom.offsetParent.scrollBy(0, -120);
			}
		},
		GetProfessionalTypeByPage() {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/GetProfessionalTypeByPage?page=1&size=9999&pid=0',
				'GET',
				{},
				function(res) {
					console.log('获取列表',res);
					if (res.flag) {
						that.labelList = res.list;
						console.log('that.labelList',that.labelList);
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 获取列表
		GetProfessionalTypeAoll: function() {
			var that = this;
			that.$api.HttpGet('SystemData/NewOccupationInquiry', {}, function(res) {
				if (res.flag) {
					console.log('aa', res);
					const list = res.list;
					that.list = list;
					that.labelList = list;
				}
			}, function(err) {
				console.log(err);
			});
		},
		goDetail(item) {
			this.$router.push({
				path: '/occupationDetails',
				query: {
					id: item.Id
				}
			});
		},
		tabClick(id) {
			this.isTab = id;
		},
		details(nid, wid, tid) {
			this.$router.push({ path: '/majorDetails', query: { nid: nid, wid: wid, tid: tid } });
		}
	}
};
</script>

<style scoped>
.chaList dd hgroup p {
	font-size: 14px;
	color: #333;
	margin-top: 20px;
	position: relative;
	padding-right: 30px;
	margin-right: 30px;
	display: inline-block;
	cursor: pointer;
}

.chaList dd hgroup p::after {
	content: '';
	width: 1px;
	height: 14px;
	background-color: #e6e6e6;
	position: absolute;
	right: 0;
	top: 50%;
	margin-top: -7px;
	z-index: 1;
}

.chaList dd hgroup p:last-child::after {
	width: 0;
}

.chaList dd hgroup p:hover {
	opacity: 0.7;
}

.chaList dd h5 span {
	margin-right: 10px;
}

.chaList dd h5 {
	font-weight: normal;
	font-size: 14px;
	height: 60px;
	border-bottom: solid 1px #e6e6e6;
	line-height: 60px;
}

.chaList dd {
	margin-top: 20px;
}

.chaList h6 span {
	font-size: 14px;
	color: #333;
	font-weight: normal;
	margin-left: 1em;
}

.chaList h6 {
	font-size: 16px;
	color: #333;
	background-color: #eaeaea;
	position: relative;
	padding-left: 20px;
	height: 50px;
	line-height: 50px;
}

.chaList h6::after {
	content: '';
	width: 4px;
	height: 100%;
	background-color: #333;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 2;
}

.chaList li {
	margin-top: 30px;
}

.chaList {
	margin-bottom: 20px;
}

.chaBg p.on {
	background-color: #333;
	color: #fff;
}
.chaBg p.on a {
	color: #fff;
}

.chaBg p {
	font-size: 14px;
	color: #333;
	cursor: pointer;
	display: inline-block;
	background-color: transparent;
	border-radius: 4px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	min-width: 50px;
	padding: 0 10px;
	margin-right: 20px;
}
.chaBg p a {
	font-size: 14px;
	color: #333;
	width: 100%;
	text-align: center;
	display: block;
}

.chaBg {
	overflow: hidden;
	background-color: #eaeaea;
	padding: 40px;
	margin: 20px 0;
}

/* chaBg */

.gaokao {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}
</style>
